<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable :loadingTable="false" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
		},
		computed: {
			CusType() {
				return this.$store.state.MenusData.CusType;
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				rightboo: false,
				dwonleft: false,
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],
				headerData: [{
						"prop": "StatusName",
						"label": "状态",
						"columnwidth": 100
					}, {
						"prop": "VouCode",
						"label": "经销商出库单号",
						"columnwidth": 200
					}, {
						"prop": "DPDate",
						"label": "出库单日期",
						"columnwidth": 150
					}, {
						"prop": "DPMonth",
						"label": "出库单年月",
						"columnwidth": 150
					}, {
						"prop": "CreateTime",
						"label": "单据上传日期",
						"columnwidth": 150
					}, {
						"prop": "CusCode",
						"label": "分销商代码",
						"columnwidth": 100
					}, {
						"prop": "CusName",
						"label": "分销商名称",
						"columnwidth": 200
					}, {
						"prop": "WhType",
						"label": "卖方级别",
						"columnwidth": 100
					}, {
						"prop": "HPName",
						"label": "客户名称",
						"columnwidth": 200
					}, {
						"prop": "HPID",
						"label": "客户编号",
						"columnwidth": 100
					}, {
						"prop": "HosType",
						"label": "客户分类",
						"columnwidth": 100
					}, {
						"prop": "TerminalHPCode",
						"label": "终端医院编号",
						"columnwidth": 100
					}, {
						"prop": "TerminalHPName",
						"label": "终端医院名称",
						"columnwidth": 200
					}, {
						"prop": "VoucherType",
						"label": "单据类型",
						"columnwidth": 100
					}, {
						"prop": "CreatorName",
						"label": "上传人",
						"columnwidth": 200
					}, {
						"prop": "InvAddCode",
						"label": "产品型号",
						"columnwidth": 200
					}, {
						"prop": "InvName",
						"label": "产品名称",
						"columnwidth": 100
					}, {
						"prop": "Batch",
						"label": "批号",
						"columnwidth": 200
					}, {
						"prop": "ValiDate",
						"label": "有效期至",
						"columnwidth": 200
					}, {
						"prop": "InvClassName",
						"label": "产品线",
						"columnwidth": 100
					}, {
						"prop": "MFName",
						"label": "生产厂商",
						"columnwidth": 200
					}, {
						"prop": "LEVEL1",
						"label": "LEVEL1",
						"columnwidth": 100
					}, {
						"prop": "LEVEL2",
						"label": "LEVEL2",
						"columnwidth": 100
					}, {
						"prop": "LEVEL3",
						"label": "LEVEL3",
						"columnwidth": 200
					}, {
						"prop": "LEVEL4",
						"label": "LEVEL4",
						"columnwidth": 100
					}, {
						"prop": "UnitName",
						"label": "单位",
						"columnwidth": 100
					}, {
						"prop": "Quantity",
						"label": "数量",
						"columnwidth": 100
					}, {
						"prop": "FUnitName",
						"label": "辅助计量单位",
						"columnwidth": 150
					}, {
						"prop": "FQuantity",
						"label": "辅助单位数量",
						"columnwidth": 150
					}, {
						"prop": "TaxUnitPrice",
						"label": "销售价",
						"columnwidth": 100
					}, {
						"prop": "Sum",
						"label": "合计",
						"columnwidth": 100
					}, {
						"prop": "SBYear",
						"label": "自然年月",
						"columnwidth": 100
					}, {
						"prop": "ProvinceName",
						"label": "客户省份",
						"columnwidth": 100
					}, {
						"prop": "CityName",
						"label": "客户城市",
						"columnwidth": 100
					}, {
						"prop": "DistrictName",
						"label": "客户区县",
						"columnwidth": 100
					}, {
			"prop": "TechnicalOffices",
			"label": "院区/科室",
			"columnwidth": 100
		}, {
						"prop": "Doctor",
						"label": "医生姓名",
						"columnwidth": 100
					}, {
						"prop": "SurgeryType",
						"label": "手术类型",
						"columnwidth": 100
					}, {
						"prop": "VouDCode",
						"label": "明细ID",
						"columnwidth": 100
					}, {
						"prop": "StandardCost",
						"label": "标准价格",
						"columnwidth": 100
					}, {
						"prop": "StandardSum",
						"label": "标准价格合计",
						"columnwidth": 120
					}, {
						"prop": "BillQuantity",
						"label": "开票数量",
						"columnwidth": 100
					}, {
						"prop": "BillStandardSum",
						"label": "开票参考价格合计",
						"columnwidth": 150
					}, {
						"prop": "InvoiceNo",
						"label": "发票号",
						"columnwidth": 100
					}, {
						"prop": "BillTaxUnitPrice",
						"label": "开票单价",
						"columnwidth": 100
					}, {
						"prop": "BillSum",
						"label": "开票金额",
						"columnwidth": 100
					}, {
						"prop": "BillCheckedStatusName",
						"label": "发票校验状态",
						"columnwidth": 200
					}, {
						"prop": "SBDate",
						"label": "发票日期",
						"columnwidth": 200
					}, {
						"prop": "SalesMan",
						"label": "销售人员",
						"columnwidth": 200
					},{
						"prop": "ProvinceMan",
						"label": "省级经理",
						"columnwidth": 200
					}, {
						"prop": "AreaMan",
						"label": "地区经理",
						"columnwidth": 100
					}, {
						"prop": "RegionMan",
						"label": "大区经理",
						"columnwidth": 100
					}, {
						"prop": "CountryMan",
						"label": "全国总监",
						"columnwidth": 100
					}
					// {
					//   prop: 'id',
					//   label: '序号',
					//   columnwidth: 50
					// },
					// {
					//   prop: 'StatusName',
					//   label: '状态',
					//   columnwidth: 90
					// },
					// {
					//   prop: 'VouCode',
					//   label: '经销商出库单号',
					//   columnwidth: 140
					// },
					// {
					//   prop: 'DPDate',
					//   label: '出库单日期',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'CreateTime',
					//   label: '单据创建日期',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'CusCode',
					//   label: '分销商代码',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'CusName',
					//   label: '分销商名称',
					//   columnwidth: 154
					// },
					// {
					//   prop: 'WhType',
					//   label: '卖方级别',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'HPName',
					//   label: '客户名称',
					//   columnwidth: 180
					// },
					// {
					//   prop: 'HPID',
					//   label: '客户编号',
					//   columnwidth: 84
					// },
					// {
					//   prop: 'TerminalHPCode',
					//   label: '终端医院编码',
					//   columnwidth: 180
					// },
					// {
					//   prop: 'TerminalHPName',
					//   label: '终端医院名称',
					//   columnwidth: 110
					// },
					// {
					//   prop: 'HosType',
					//   label: '客户分类',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'VoucherType',
					//   label: '单据类型',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'CreatorName',
					//   label: '上传人',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'InvAddCode',
					//   label: '产品型号',
					//   columnwidth: 154
					// },
					// {
					//   prop: 'InvName',
					//   label: '产品名称',
					//   columnwidth: 154
					// },
					// {
					//   prop: 'Batch',
					//   label: '批号',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'ValiDate',
					//   label: '有效期至',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'LEVEL1',
					//   label: 'LEVEL1',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'LEVEL2',
					//   label: 'LEVEL2',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'LEVEL3',
					//   label: 'LEVEL3',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'LEVEL4',
					//   label: 'LEVEL4',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'UnitName',
					//   label: '单位',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'Quantity',
					//   label: '数量',
					//   columnwidth: 50
					// },
					// {
					//   prop: 'TaxUnitPrice',
					//   label: '销售价',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'Sum',
					//   label: '合计',
					//   columnwidth: 84
					// },
					// {
					//   prop: 'StandardCost',
					//   label: '参考价格',
					//   columnwidth: 84
					// },
					// {
					//   prop: 'StandardSum',
					//   label: '参考价格合计',
					//   columnwidth: 84
					// },
					// {
					//   prop: 'BillQuantity',
					//   label: '开票数量',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'BillStandardSum',
					//   label: '开票参考价格合计',
					//   columnwidth: 84
					// },
					// {
					//   prop: 'InvoiceNo',
					//   label: '发票号',
					//   columnwidth: 80
					// },
					// // {
					// //   prop: 'BillStatusName',
					// //   label: '发票状态',
					// //   columnwidth: 80
					// // },
					// {
					//   prop: 'BillTaxUnitPrice',
					//   label: '开票单价',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'BillSum',
					//   label: '开票金额',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'SBDate',
					//   label: '发票日期',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'SBYear',
					//   label: '自然年月',
					//   columnwidth: 154
					// },
					// {
					//   prop: 'SalesMan',
					//   label: '销售员',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'PSalesMan',
					//   label: '销售员上级',
					//   columnwidth: 120
					// },
					// {
					//   prop: 'PPSalesMan',
					//   label: '销售员上上级',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'ProvinceName',
					//   label: '客户省份',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'CityName',
					//   label: '客户城市',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'DistrictName',
					//   label: '客户区县',
					//   columnwidth: 80
					// },
					// {
					//   prop: 'TechnicalOffices',
					//   label: '科室名称',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'Doctor',
					//   label: '医生姓名',
					//   columnwidth: 130
					// },
					// {
					//   prop: 'SurgeryType',
					//   label: '手术类型',
					//   columnwidth: 100
					// },
					// {
					//   prop: 'VouDCode',
					//   label: '明细ID',
					//   columnwidth: 100
					// }
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			console.log(this.headerData)
			if (this.CusType) {
				this.headerData.splice(39, 13);
				console.log('========>', this.CusType);
			}
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == NodeID) {
						this.qus = item.Nodes[index].Nodes
					}
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						}
					})
				}
			},
			Export() {
				this.$emit('Export')
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>